export type PriceType = 'FIXED' | 'VARIABLE';

export const PRICE_TYPE_OPTIONS: { value: PriceType; label: string }[] = [
    { value: 'FIXED', label: 'Fixed' },
    { value: 'VARIABLE', label: 'Variable' },
];
